import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.unshift.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
var fileDownload = require("js-file-download");
import * as xlsx from "xlsx";
import moment from "moment";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { formRules } from "@/js/form_rules.js";
import { getErrorData } from "@/js/forms.js";
import { filterIntegerKey } from "@/js/events/keycodes.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import UploaderPrices from "@/components/default/UploaderV2.vue";
import SupplierSelectComponent from "@/components/supplier-prices/SupplierSelectComponent.vue";
import NewWineDialog from "@/components/products/NewWineDialog.vue";
import ImportSupplierPricesHeader from "@/components/supplier-prices/ImportSupplierPricesHeader.vue";
import AssociateWineModal from "@/components/products/AssociateWine/AssociateWineModal.vue";
var NB_ROWS_TO_FIND_ROWTITLE = 50;
var FIELD_TYPES = {
  PRICE: {
    value: "price"
  },
  BOTTLING: {
    value: "bottling"
  },
  NAME: {
    value: "name"
  },
  VINTAGE: {
    value: "vintage"
  },
  TYPE: {
    value: "type"
  },
  QUANTITY: {
    value: "quantity"
  }
};
var defaultSheetToImport = {
  sheetName: "",
  rows: [],
  columns: [],
  form: {
    isActive: true,
    isAutoDuplicateMissingVintageOrBottling: true,
    preparationActions: "",
    rowTitle: 0,
    price: {
      columnName: "",
      fieldType: FIELD_TYPES.PRICE.value
    },
    bottling: {
      columnName: "",
      unit: null,
      fieldType: FIELD_TYPES.BOTTLING.value
    },
    names: [{
      columnName: "",
      fieldType: FIELD_TYPES.NAME.value
    }],
    vintage: {
      columnName: "",
      fieldType: FIELD_TYPES.VINTAGE.value
    },
    type: {
      columnName: "",
      fieldType: FIELD_TYPES.TYPE.value
    },
    quantity: {
      columnName: "",
      fieldType: FIELD_TYPES.QUANTITY.value
    },
    quantityDefault: 60,
    productlinkReplacements: [],
    productlinkExcludedColumns: [],
    valid: false
  }
};
export var supplierPriceVolumeUnits = [{
  id: "ml",
  text: "Milliliter"
}, {
  id: "cl",
  text: "Centiliter"
}, {
  id: "dl",
  text: "Deciliter"
}, {
  id: "L",
  text: "Liter"
}, {
  id: "Caza",
  text: "Cazabonne bottlings"
}, {
  id: "Gericot",
  text: "Gericot bottlings"
}];
export var supplierPriceTypeVersions = [{
  id: "rouge",
  text: "Rouge / Blanc"
}, {
  id: "red",
  text: "Red / White"
}];
export default {
  name: "ImportSupplierPrices",
  components: {
    SupplierSelectComponent: SupplierSelectComponent,
    UploaderPrices: UploaderPrices,
    Confirm: Confirm,
    NewWineDialog: NewWineDialog,
    ImportSupplierPricesHeader: ImportSupplierPricesHeader,
    AssociateWineModal: AssociateWineModal
  },
  props: {
    value: Boolean,
    loggedUserData: Object
  },
  data: function data() {
    return {
      isConfiguring: true,
      isSyncingFile: false,
      atLeastOneSheetValid: false,
      isImporting: false,
      fetchSuppliersToken: null,
      isSavingSettings: false,
      saveSupplierSettingsToken: null,
      updateWineSupplierPriceToken: null,
      suppliers: [],
      supplierId: null,
      sheetNamesOfFile: [],
      sheetsToImport: [],
      headers: [{
        text: "Sheet",
        value: "sheetName",
        align: "center"
      }, {
        text: "Line",
        value: "lineNumber",
        align: "center"
      }, {
        text: "",
        value: "status",
        align: "center"
      }, {
        text: "Description",
        value: "description",
        align: "left"
      }, {
        text: "SupplierCogs",
        value: "supplierCogs",
        align: "center"
      }, {
        text: "Actions",
        value: "actions",
        align: "left"
      }],
      items: [],
      result: {
        success: 0,
        warning: 0,
        danger: 0
      },
      formFilters: {
        status: {
          options: [{
            id: 0,
            name: "Not imported"
          }, {
            id: 2,
            name: "Imported & not linked to wine"
          }, {
            id: 1,
            name: "Imported & linked to wine"
          }],
          selected: []
        }
      },
      createWineModal: {
        isVisible: false,
        selectedSupplierPrice: {}
      },
      associateWine: {
        selectedSupplierPrice: {}
      },
      rules: formRules,
      supplierPriceVolumeUnits: supplierPriceVolumeUnits,
      supplierPriceTypeVersions: supplierPriceTypeVersions
    };
  },
  computed: {
    shown: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit("input", value);
      }
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.isImporting || this.isSavingSettings;
    },
    hasValidFile: function hasValidFile() {
      return this.atLeastOneSheetValid;
    },
    canBeSubmitted: function canBeSubmitted() {
      return this.sheetsToImport.some(function (x) {
        return x.form.isActive;
      }) && !this.sheetsToImport.some(function (x) {
        return x.form.isActive && !x.form.valid;
      });
    },
    uploadUrl: function uploadUrl() {
      return "".concat(process.env.VUE_APP_API_URL, "/v1/suppliers/import-prices?supplierId=").concat(this.supplierId);
    },
    resultItemsSorted: function resultItemsSorted() {
      var _this$items;
      if (((_this$items = this.items) === null || _this$items === void 0 ? void 0 : _this$items.length) > 0) {
        return this.items.sort(function (a, b) {
          if (b.status !== a.status) {
            return b.status - a.status;
          }
          return a.lineNumber - b.lineNumber;
        });
      } else {
        return [];
      }
    },
    filteredRows: function filteredRows() {
      var sel = this.formFilters.status.selected;
      if (!sel.length) return this.resultItemsSorted;
      return this.resultItemsSorted.filter(function (r) {
        return sel.includes(r.status);
      });
    },
    getSelectedSupplierImportSettingsSheets: function getSelectedSupplierImportSettingsSheets() {
      var _this$suppliers$find,
        _this2 = this;
      return (_this$suppliers$find = this.suppliers.find(function (x) {
        return x.id == _this2.supplierId;
      })) === null || _this$suppliers$find === void 0 ? void 0 : _this$suppliers$find.importPriceSetting.sheets;
    },
    selectedSupplierhasPreparationActions: function selectedSupplierhasPreparationActions() {
      return this.supplierId && this.getSelectedSupplierImportSettingsSheets.some(function (sheet) {
        return sheet.preparationActions && sheet.preparationActions.trim() !== "";
      });
    }
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this3.fetchSuppliers();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    saveSupplierSettings: function saveSupplierSettings() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this4$saveSupplierSe;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                sheets: []
              };
              _this4.sheetsToImport.forEach(function (sheetToImport) {
                var sheet = {
                  name: sheetToImport.sheetName,
                  isAutoDuplicateMissingVintageOrBottling: sheetToImport.form.isAutoDuplicateMissingVintageOrBottling,
                  preparationActions: sheetToImport.form.preparationActions,
                  isActive: sheetToImport.form.isActive,
                  rowTitle: sheetToImport.form.rowTitle,
                  details: [],
                  quantityDefault: sheetToImport.form.quantityDefault,
                  productlinkReplacements: _toConsumableArray(sheetToImport.form.productlinkReplacements),
                  productlinkExcludedColumns: _toConsumableArray(sheetToImport.form.productlinkExcludedColumns)
                };
                sheet.details.push(_objectSpread({}, sheetToImport.form.price));
                sheet.details.push(_objectSpread({}, sheetToImport.form.bottling));
                sheet.details.push(_objectSpread({}, sheetToImport.form.vintage));
                sheet.details.push(_objectSpread({}, sheetToImport.form.type));
                sheet.details.push(_objectSpread({}, sheetToImport.form.quantity));
                sheetToImport.form.names.forEach(function (x) {
                  sheet.details.push(_objectSpread({}, x));
                });
                data.sheets.push(sheet);
              });
              _this4.isSavingSettings = true;
              (_this4$saveSupplierSe = _this4.saveSupplierSettingsToken) === null || _this4$saveSupplierSe === void 0 || _this4$saveSupplierSe.cancel();
              _this4.saveSupplierSettingsToken = axios.CancelToken.source();
              _this = _this4;
              _context2.next = 8;
              return request("/v1/suppliers/".concat(_this4.supplierId, "/import-price-settings"), "post", data, true, "api", null, _this4.saveSupplierSettingsToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  _this.isSavingSettings = false;
                  _this.$toasted.show("Unable to save supplier settings.", {
                    type: "error"
                  });
                  throw e;
                }
              });
            case 8:
              _this4.isSavingSettings = false;
              _this4.suppliers.find(function (x) {
                return x.id === _this4.supplierId;
              }).importPriceSetting = _objectSpread({}, data);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    submit: function submit() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var confirmed, _this;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              confirmed = true;
              _context3.next = 3;
              return _this5.$refs.confirm.open("Confirm import", "Are you sure you want to import the file?", {
                color: "red"
              });
            case 3:
              confirmed = _context3.sent;
              if (!confirmed) {
                _context3.next = 10;
                break;
              }
              _this = _this5;
              _this5.isImporting = true;
              _context3.next = 9;
              return _this5.saveSupplierSettings().catch(function (e) {
                _this.isImporting = false;
                throw e;
              });
            case 9:
              _this5.$refs.uploader_supplierprices.uploadAll(true);
            case 10:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    acknowledgeUpload: function acknowledgeUpload(response) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.items = response.data.value.map(function (x) {
                var status = 0;
                var statusLabel = "";
                if (x.wineId) {
                  status = 1;
                  statusLabel = "success";
                  _this6.result.success += 1;
                } else if (x.description) {
                  status = 2;
                  statusLabel = "warning";
                  _this6.result.warning += 1;
                } else if (x.errorMessage) {
                  status = 3;
                  statusLabel = "danger";
                  x.description = x.errorMessage;
                  _this6.result.danger += 1;
                }
                return _objectSpread(_objectSpread({}, x), {}, {
                  status: status,
                  statusLabel: statusLabel
                });
              });
              _this6.isConfiguring = false;
              _this6.isImporting = false;
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    fetchSuppliersWhenItemsUpdated: function fetchSuppliersWhenItemsUpdated(supplierId) {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this7.fetchSuppliers();
            case 2:
              _this7.changeSupplier(supplierId);
              _this7.$refs.supplierSelect.updateModel(supplierId);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    changeSupplier: function changeSupplier(supplierId) {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this8.supplierId = supplierId;
              _context6.next = 3;
              return _this8.restart();
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    syncFiles: function syncFiles(files) {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var data, workbook, wbJson;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this9.isSyncingFile = true;
              _this9.sheetNamesOfFile = [];
              _this9.sheetsToImport = [];
              _this9.atLeastOneSheetValid = false;
              if (!(files !== null && files !== void 0 && files.length)) {
                _context7.next = 19;
                break;
              }
              _context7.next = 7;
              return files[0].arrayBuffer();
            case 7:
              data = _context7.sent;
              workbook = xlsx.read(data);
              wbJson = File.transformSheetToJson(workbook);
              _this9.sheetNamesOfFile = workbook.SheetNames.map(function (sheetName) {
                return {
                  text: sheetName,
                  value: sheetName
                };
              });
              _context7.next = 13;
              return _this9.processSheetNames(wbJson);
            case 13:
              if (_this9.atLeastOneSheetValid) {
                _context7.next = 17;
                break;
              }
              _this9.$toasted.show("Invalid file, no valid sheet.", {
                type: "error"
              });
              _context7.next = 19;
              break;
            case 17:
              _context7.next = 19;
              return _this9.getExistingSetting();
            case 19:
              _this9.isSyncingFile = false;
            case 20:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    processSheetNames: function processSheetNames(wbJson) {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this10$sheetNamesOfF;
        var _iterator, _step, _loop;
        return _regeneratorRuntime().wrap(function _callee8$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(((_this10$sheetNamesOfF = _this10.sheetNamesOfFile) === null || _this10$sheetNamesOfF === void 0 ? void 0 : _this10$sheetNamesOfF.length) > 0)) {
                _context9.next = 17;
                break;
              }
              _iterator = _createForOfIteratorHelper(_this10.sheetNamesOfFile);
              _context9.prev = 2;
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop() {
                var sheetNameObject, sheetName, sheetToImport, i, _wbJson$sheetName$i, columns, dataSheetToImport;
                return _regeneratorRuntime().wrap(function _loop$(_context8) {
                  while (1) switch (_context8.prev = _context8.next) {
                    case 0:
                      sheetNameObject = _step.value;
                      sheetName = sheetNameObject.value;
                      if (!wbJson[sheetName]) {
                        _context8.next = 11;
                        break;
                      }
                      sheetToImport = _objectSpread({}, Object.deepCopy(defaultSheetToImport));
                      sheetToImport.sheetName = sheetName;
                      for (i = 0; i < NB_ROWS_TO_FIND_ROWTITLE; i++) {
                        columns = (_wbJson$sheetName$i = wbJson[sheetName][i]) === null || _wbJson$sheetName$i === void 0 ? void 0 : _wbJson$sheetName$i.map(function (x) {
                          return typeof x === "string" ? x.trim() : x;
                        });
                        if ((columns === null || columns === void 0 ? void 0 : columns.length) > 0) {
                          sheetToImport.rows.push({
                            id: i,
                            name: "".concat(i + 1, " - ").concat(columns.join(", ")),
                            //If first column is on B, it will show "A" ... due to xlsx.utils.sheet_to_json, external library
                            columns: columns
                          });
                        } else {
                          sheetToImport.rows.push({
                            id: i,
                            name: "".concat(i + 1),
                            columns: []
                          });
                        }
                      }
                      _this10.sheetsToImport.push(sheetToImport);
                      dataSheetToImport = _this10.sheetsToImport.find(function (x) {
                        return x.sheetName === sheetName;
                      });
                      _context8.next = 10;
                      return _this10.selectRowTitle(dataSheetToImport);
                    case 10:
                      _this10.atLeastOneSheetValid = true;
                    case 11:
                    case "end":
                      return _context8.stop();
                  }
                }, _loop);
              });
              _iterator.s();
            case 5:
              if ((_step = _iterator.n()).done) {
                _context9.next = 9;
                break;
              }
              return _context9.delegateYield(_loop(), "t0", 7);
            case 7:
              _context9.next = 5;
              break;
            case 9:
              _context9.next = 14;
              break;
            case 11:
              _context9.prev = 11;
              _context9.t1 = _context9["catch"](2);
              _iterator.e(_context9.t1);
            case 14:
              _context9.prev = 14;
              _iterator.f();
              return _context9.finish(14);
            case 17:
            case "end":
              return _context9.stop();
          }
        }, _callee8, null, [[2, 11, 14, 17]]);
      }))();
    },
    getExistingSetting: function getExistingSetting() {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var importSetting;
        return _regeneratorRuntime().wrap(function _callee10$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              importSetting = _this11.suppliers.find(function (x) {
                return x.id === _this11.supplierId;
              }).importPriceSetting;
              if ((importSetting === null || importSetting === void 0 ? void 0 : importSetting.sheets.length) > 0) {
                _this11.sheetsToImport.forEach(/*#__PURE__*/function () {
                  var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(sheetToImport) {
                    var sheetSetting, priceSetting, bottlingSetting, nameSettings, vintageSetting, typeSetting, quantitySetting;
                    return _regeneratorRuntime().wrap(function _callee9$(_context10) {
                      while (1) switch (_context10.prev = _context10.next) {
                        case 0:
                          sheetSetting = importSetting.sheets.find(function (x) {
                            return x.name === sheetToImport.sheetName;
                          });
                          if (!sheetSetting) {
                            _context10.next = 22;
                            break;
                          }
                          sheetToImport.form.preparationActions = sheetSetting.preparationActions;
                          sheetToImport.form.quantityDefault = sheetSetting.quantityDefault;
                          sheetToImport.form.isActive = sheetSetting.isActive;
                          sheetToImport.form.rowTitle = sheetSetting.rowTitle;
                          _context10.next = 8;
                          return _this11.selectRowTitle(sheetToImport);
                        case 8:
                          priceSetting = sheetSetting.details.find(function (x) {
                            return x.fieldType === FIELD_TYPES.PRICE.value;
                          });
                          sheetToImport.form.price = _objectSpread({}, priceSetting);
                          bottlingSetting = sheetSetting.details.find(function (x) {
                            return x.fieldType === FIELD_TYPES.BOTTLING.value;
                          });
                          sheetToImport.form.bottling = _objectSpread({}, bottlingSetting);
                          nameSettings = sheetSetting.details.filter(function (x) {
                            return x.fieldType === FIELD_TYPES.NAME.value;
                          }).sort(function (a, b) {
                            return a.sort - b.sort;
                          });
                          sheetToImport.form.names = _toConsumableArray(nameSettings);
                          vintageSetting = sheetSetting.details.find(function (x) {
                            return x.fieldType === FIELD_TYPES.VINTAGE.value;
                          });
                          if (vintageSetting) {
                            sheetToImport.form.vintage = _objectSpread({}, vintageSetting);
                          }
                          typeSetting = sheetSetting.details.find(function (x) {
                            return x.fieldType === FIELD_TYPES.TYPE.value;
                          });
                          if (typeSetting) {
                            sheetToImport.form.type = _objectSpread({}, typeSetting);
                          }
                          quantitySetting = sheetSetting.details.find(function (x) {
                            return x.fieldType === FIELD_TYPES.QUANTITY.value;
                          });
                          if (vintageSetting) {
                            sheetToImport.form.quantity = _objectSpread({}, quantitySetting);
                          }
                          sheetToImport.form.productlinkReplacements = _toConsumableArray(sheetSetting.productlinkReplacements);
                          sheetToImport.form.productlinkExcludedColumns = _toConsumableArray(sheetSetting.productlinkExcludedColumns);
                        case 22:
                        case "end":
                          return _context10.stop();
                      }
                    }, _callee9);
                  }));
                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }());
              }
            case 2:
            case "end":
              return _context11.stop();
          }
        }, _callee10);
      }))();
    },
    selectRowTitle: function selectRowTitle(sheetToImport) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        return _regeneratorRuntime().wrap(function _callee11$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (sheetToImport.form.rowTitle != null && sheetToImport.rows.length) {
                sheetToImport.columns = sheetToImport.rows.find(function (x) {
                  return x.id == sheetToImport.form.rowTitle;
                }).columns.map(function (x, i) {
                  return {
                    id: x,
                    name: "".concat(_this12.columnIndexToColumnLetter(i), " - ").concat(x)
                  };
                });
              } else {
                sheetToImport.columns = [];
              }
            case 1:
            case "end":
              return _context12.stop();
          }
        }, _callee11);
      }))();
    },
    additionnalFieldName: function additionnalFieldName(sheetToImport) {
      sheetToImport.form.names.push({
        columnName: "",
        fieldType: "name"
      });
    },
    removeFieldName: function removeFieldName(sheetToImport, index) {
      sheetToImport.form.names.splice(index, 1);
    },
    removeLastFieldName: function removeLastFieldName(sheetToImport) {
      sheetToImport.form.names.splice(-1);
    },
    positionFieldNameUp: function positionFieldNameUp(sheetToImport, index) {
      var list = sheetToImport.form.names;
      if (index > 0) {
        var tmp = list[index];
        list.splice(index, 1);
        list.splice(index - 1, 0, tmp);
      }
    },
    positionFieldNameToFullTop: function positionFieldNameToFullTop(sheetToImport, index) {
      var list = sheetToImport.form.names;
      var item = list[index];
      list.splice(index, 1);
      list.unshift(item);
    },
    positionFieldNameDown: function positionFieldNameDown(sheetToImport, index) {
      var list = sheetToImport.form.names;
      if (index < list.length - 1) {
        var tmp = list[index];
        list.splice(index, 1);
        list.splice(index + 1, 0, tmp);
      }
    },
    positionFieldNameToFullBottom: function positionFieldNameToFullBottom(sheetToImport, index) {
      var list = sheetToImport.form.names;
      var item = list[index];
      list.splice(index, 1);
      list.push(item);
    },
    addExcludedColumn: function addExcludedColumn(sheetToImport) {
      sheetToImport.form.productlinkExcludedColumns.push({
        toReplace: "",
        replaceBy: ""
      });
    },
    removeLastExcludedColumn: function removeLastExcludedColumn(sheetToImport) {
      sheetToImport.form.productlinkExcludedColumns.splice(-1);
    },
    removeExcludedColumn: function removeExcludedColumn(sheetToImport, index) {
      sheetToImport.form.productlinkExcludedColumns.splice(index, 1);
    },
    positionExcludedColumnUp: function positionExcludedColumnUp(sheetToImport, index) {
      var list = sheetToImport.form.productlinkExcludedColumns;
      if (index > 0) {
        var tmp = list[index];
        list.splice(index, 1);
        list.splice(index - 1, 0, tmp);
      }
    },
    positionExcludedColumnToFullTop: function positionExcludedColumnToFullTop(sheetToImport, index) {
      var list = sheetToImport.form.productlinkExcludedColumns;
      var item = list[index];
      list.splice(index, 1);
      list.unshift(item);
    },
    positionExcludedColumnDown: function positionExcludedColumnDown(sheetToImport, index) {
      var list = sheetToImport.form.productlinkExcludedColumns;
      if (index < list.length - 1) {
        var tmp = list[index];
        list.splice(index, 1);
        list.splice(index + 1, 0, tmp);
      }
    },
    positionExcludedColumnToFullBottom: function positionExcludedColumnToFullBottom(sheetToImport, index) {
      var list = sheetToImport.form.productlinkExcludedColumns;
      var item = list[index];
      list.splice(index, 1);
      list.push(item);
    },
    addReplacement: function addReplacement(sheetToImport) {
      sheetToImport.form.productlinkReplacements.push({
        toReplace: "",
        replaceBy: ""
      });
    },
    removeLastReplacement: function removeLastReplacement(sheetToImport) {
      sheetToImport.form.productlinkReplacements.splice(-1);
    },
    removeReplacement: function removeReplacement(sheetToImport, index) {
      sheetToImport.form.productlinkReplacements.splice(index, 1);
    },
    positionReplacementUp: function positionReplacementUp(sheetToImport, index) {
      var list = sheetToImport.form.productlinkReplacements;
      if (index > 0) {
        var tmp = list[index];
        list.splice(index, 1);
        list.splice(index - 1, 0, tmp);
      }
    },
    positionReplacementToFullTop: function positionReplacementToFullTop(sheetToImport, index) {
      var list = sheetToImport.form.productlinkReplacements;
      var item = list[index];
      list.splice(index, 1);
      list.unshift(item);
    },
    positionReplacementDown: function positionReplacementDown(sheetToImport, index) {
      var list = sheetToImport.form.productlinkReplacements;
      if (index < list.length - 1) {
        var tmp = list[index];
        list.splice(index, 1);
        list.splice(index + 1, 0, tmp);
      }
    },
    positionReplacementToFullBottom: function positionReplacementToFullBottom(sheetToImport, index) {
      var list = sheetToImport.form.productlinkReplacements;
      var item = list[index];
      list.splice(index, 1);
      list.push(item);
    },
    uploadFailed: function uploadFailed() {
      this.isImporting = false;
    },
    fetchSuppliers: function fetchSuppliers() {
      var _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var _this13$fetchSupplier;
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee12$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              (_this13$fetchSupplier = _this13.fetchSuppliersToken) === null || _this13$fetchSupplier === void 0 || _this13$fetchSupplier.cancel();
              _this13.fetchSuppliersToken = axios.CancelToken.source();
              _this = _this13;
              _context13.next = 5;
              return request("/v1/suppliers?withImportSettings=true", "get", null, true, "api", null, _this13.fetchSuppliersToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to load suppliers.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 5:
              response = _context13.sent;
              if (response) {
                _this13.suppliers = response.data.value.sort(function (a, b) {
                  if (a.producerId === null !== (b.producerId === null)) {
                    return a.producerId === null ? -1 : 1;
                  }
                  return a.name.localeCompare(b.name);
                }).map(function (supplier) {
                  return _objectSpread(_objectSpread({}, supplier), {}, {
                    display_name: "".concat(supplier.name, " (").concat(supplier.producerId ? "producer" : "supplier", ")")
                  });
                });
              }
            case 7:
            case "end":
              return _context13.stop();
          }
        }, _callee12);
      }))();
    },
    close: function close() {
      var _this$$refs$uploader_;
      (_this$$refs$uploader_ = this.$refs.uploader_supplierprices) === null || _this$$refs$uploader_ === void 0 || _this$$refs$uploader_.cancelUpload();
      this.syncFiles(null);
      this.$emit("input", false);
    },
    restart: function restart() {
      var _this14 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this14$$refs$uploade;
        return _regeneratorRuntime().wrap(function _callee13$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _this14.isConfiguring = true;
              _this14.isSyncingFile = false;
              _this14.atLeastOneSheetValid = false;
              _this14.sheetsToImport = [];
              _this14.items = [];
              _this14.result = {
                success: 0,
                warning: 0,
                danger: 0
              };
              (_this14$$refs$uploade = _this14.$refs.uploader_supplierprices) === null || _this14$$refs$uploade === void 0 || _this14$$refs$uploade.resetFiles();
            case 7:
            case "end":
              return _context14.stop();
          }
        }, _callee13);
      }))();
    },
    cancel: function cancel() {
      var _this15 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        return _regeneratorRuntime().wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return _this15.restart();
            case 2:
              _this15.close();
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee14);
      }))();
    },
    columnIndexToColumnLetter: function columnIndexToColumnLetter(colIndex) {
      var div = colIndex + 1;
      var colLetter = "";
      var mod = 0;
      while (div > 0) {
        mod = (div - 1) % 26;
        colLetter = String.fromCharCode(65 + mod) + colLetter;
        div = parseInt((div - mod) / 26);
      }
      return colLetter;
    },
    toProductDetails: function toProductDetails(item) {
      var query = {};
      return {
        name: "adminWineDetails",
        query: query,
        params: {
          id: item.wineId
        }
      };
    },
    openCreateWineDialog: function openCreateWineDialog(supplierPrice) {
      this.createWineModal.selectedSupplierPrice = supplierPrice;
      this.createWineModal.isVisible = true;
    },
    closeCreateWineDialog: function closeCreateWineDialog() {
      this.createWineModal.isVisible = false;
    },
    createWineSavedDialog: function createWineSavedDialog(response) {
      this.updateWineSupplierPrice(response);
    },
    openAssociateWineModal: function openAssociateWineModal(supplierPrice) {
      this.$refs.associateWineModal.open();
      this.associateWine.selectedSupplierPrice = supplierPrice;
    },
    associateWineToSupplierPrice: function associateWineToSupplierPrice(wineId) {
      this.updateWineSupplierPrice({
        wineSupplierPriceId: this.associateWine.selectedSupplierPrice.wineSupplierPriceId,
        wineId: wineId
      });
    },
    updateWineSupplierPriceItemLine: function updateWineSupplierPriceItemLine(wineSupplierPriceId, wineId) {
      var line = this.items.find(function (x) {
        return x.wineSupplierPriceId === wineSupplierPriceId;
      });
      if (line) {
        line.status = 1;
        line.statusLabel = "success";
        line.wineId = wineId;
      }
    },
    updateWineSupplierPrice: function updateWineSupplierPrice(item) {
      var _this16 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        var _this16$updateWineSup;
        var data, _this;
        return _regeneratorRuntime().wrap(function _callee15$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              (_this16$updateWineSup = _this16.updateWineSupplierPriceToken) === null || _this16$updateWineSup === void 0 || _this16$updateWineSup.cancel();
              _this16.updateWineSupplierPriceToken = axios.CancelToken.source();
              data = {
                wineId: item.wineId
              };
              _this = _this16;
              _context16.next = 6;
              return request("/v1/suppliers/wine-price/".concat(item.wineSupplierPriceId), "put", data, true, "api", null, _this16.updateWineSupplierPriceToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, _this.managedExceptions, "Unable to update wine supplier price.");
                  _this.$toasted.show(errorData.message, {
                    type: errorData.type
                  });
                  throw e;
                }
              });
            case 6:
              _this16.closeCreateWineDialog();
              _this16.updateWineSupplierPriceItemLine(item.wineSupplierPriceId, item.wineId);
              _this16.$toasted.show("Wine attached to supplier price line.", {
                type: "success"
              });
            case 9:
            case "end":
              return _context16.stop();
          }
        }, _callee15);
      }))();
    },
    exportErrors: function exportErrors() {
      var _this17 = this;
      var supplierName = this.suppliers.find(function (x) {
        return x.id === _this17.supplierId;
      }).name;
      var formattedDate = moment().format("YYYY-MM-DD");
      var fileName = "IMPORT_SUPPLIER_PRICES_ERRORS-".concat(supplierName, "-").concat(formattedDate, ".xlsx");
      var data = this.items.map(function (item) {
        return {
          Sheet: item.sheetName,
          Line: item.lineNumber,
          Result: item.statusLabel === "warning" ? "imported & not linked to wine" : item.statusLabel === "danger" ? "not imported" : item.statusLabel === "success" ? "Linked to wine #" + item.wineId : "unknown error",
          Description: item.description,
          AutoLink: item.statusLabel === "warning" ? item.nameForProductLink : "",
          SupplierCogs: item.statusLabel === "warning" ? item.supplierCogs : ""
        };
      });
      var worksheet = xlsx.utils.json_to_sheet(data);
      var workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Errors");
      var excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array"
      });
      var dataBlob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      fileDownload(dataBlob, fileName, "application/xlsx");
    },
    filterIntegerKey: filterIntegerKey
  }
};